if (!customElements.get('product-form')) {
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.variantIdInput.disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
    this.cartMain = document.querySelector('cart-main');
    this.cartFooter = document.getElementById('cart-footer');
    this.siteHeader = document.querySelector('.section--site-header');
    this.cartDrawer = document.getElementById('cart-drawer');
    this.submitButton = this.querySelector('[type="submit"]');
    this.submitButtonText = this.submitButton.querySelector('span');

    this.hideErrors = this.dataset.hideErrors === 'true';
  }

  get cartItems() {
    return document.querySelector('cart-items');
  }

  get cartDrawerOpener() {
    return document.getElementById('cart-drawer-opener');
  }

  onSubmitHandler(event) {
    event.preventDefault();

    if (this.submitButton.classList.contains('loading')) return;

    this.handleErrorMessage();

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);

    // Prep main cart sections for updates on the cart page no matter the cart type
    if (themeSettings.template_name === 'cart') {
      formData.append('sections', this.cartMain.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
    // Prep cart notification for updates
    } else if (themeSettings.cart_type === 'page') {
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
    // Prep cart drawer for updates
    } else {
      formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
    }

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });

          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.js-sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('display--hidden');
          soldOutMessage.classList.remove('display--none');
          soldOutMessage.classList.remove('display--hidden');
          soldOutMessage.setAttribute('aria-hidden', 'false');
          this.error = true;
          return;
        }

        document.querySelectorAll('simple-modal-dialog').forEach((dialog) => {
          dialog.hide();
        });

        if (window.GoldNMetaFunnel && typeof window.GoldNMetaFunnel.productAdded === 'function') {
          window.GoldNMetaFunnel.productAdded(response);
        }

        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');

        if (!this.error) {
          // Main cart sections renders updates on the cart page no matter the cart type
          if (themeSettings.template_name === 'cart') {
            this.renderSections(this.cartMain.getSectionsToRender(), response.sections);
            this.cartItems?.querySelector('#cart-items-loader')?.classList.add('display--hidden');
            this.cartItems?.hideEmptyCart();
            window.scrollTo({top: 0, behavior: 'smooth'});
            this.publishCartUpdate(formData, response, startMarker, true);
          // Cart notification renders updates
          } else if (themeSettings.cart_type === 'page') {
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderContents(response);
            this.cartNotification.open();
            this.publishCartUpdate(formData, response, startMarker, true);
          // Cart drawer renders updates
          } else {
            this.renderDrawerCart(response);
            this.publishCartUpdate(formData, response, startMarker, true);
          }
        }
        this.error = false;
      })
      .catch((e) => {
        console.error(e);
        this.cartItems?.querySelector('#cart-items-loader')?.classList.remove('display--hidden');
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        CartPerformance.measureFromEvent("add:user-action", event);
      });
  }

  publishCartUpdate(formData, response, startMarker, sectionsRendered) {
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'product-form',
      productVariantId: formData.get('id'),
      cartData: response,
      sectionsRendered,
    }).then(() => {
      CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
    });
  }

  renderDrawerCart(response) {
    const cartItems = this.cartItems;
    const loader = cartItems?.querySelector('#cart-items-loader');
    loader?.classList.remove('display--hidden');

    // Paint stable cart markup before opening so checkout is never mid-replace.
    this.renderSections(this.cartDrawer.getSectionsToRender(), response.sections);
    loader?.classList.add('display--hidden');
    cartItems?.hideEmptyCart();

    const drawer = this.cartDrawer || document.getElementById('cart-drawer');
    const opener = this.cartDrawerOpener;
    const drawerWasHidden = drawer?.hasAttribute('hidden');

    if (drawer) {
      this.cartDrawer?.setActiveElement?.(document.activeElement);
      if (drawerWasHidden && opener) {
        opener.openDrawer();
      } else {
        drawer.removeAttribute('hidden');
        drawer.setAttribute('open', true);
        drawer.classList.add('menu-opening');
        document.documentElement.classList.add('overlay-on');
      }
      trapFocus(drawer);
    }
  }

  renderSections(sectionsConfig, sectionsHtml) {
    if (!sectionsConfig || !sectionsHtml) return;

    sectionsConfig.forEach((section) => {
      const sectionHtml = sectionsHtml[section.id] || sectionsHtml[section.section];
      if (!sectionHtml) return;

      const root = document.getElementById(section.id);
      if (!root) return;

      const target = root.querySelector(section.selector) || root;
      const parsed = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (parsed == null) return;
      target.innerHTML = parsed;
    });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('[data-error-message-wrapper]');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('[data-error-message]');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  toggleSubmitButton(disable = true, text) {
    const soldOutMessage = this.submitButton.querySelector('.js-sold-out-message');

    if (disable) {
      this.submitButton.setAttribute('disabled', 'disabled');
      if (text) this.submitButtonText.textContent = text;
    } else {
      this.submitButton.removeAttribute('disabled');
      this.submitButtonText.classList.remove('display--hidden');
      this.submitButtonText.textContent = window.variantStrings.addToCart;

      if (soldOutMessage) {
        soldOutMessage.classList.add('display--none');
        soldOutMessage.classList.add('display--hidden');
        soldOutMessage.setAttribute('aria-hidden', 'true');
      }
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    return element ? element.innerHTML : null;
  }

  get variantIdInput() {
    return this.form.querySelector('[name=id]');
  }
}

customElements.define('product-form', ProductForm);
}
